/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CampaignProperties } from './campaign-properties';


export interface CampaignDto { 
    id: string;
    programId: string;
    name: string;
    slug: string;
    active: boolean;
    type: CampaignDto.TypeEnum;
    properties: CampaignProperties;
    timezone: string;
    startedAt: object;
    finishedAt: object;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    assignations: number;
}
export namespace CampaignDto {
    export const TypeEnum = {
        _0: '0',
        _1: '1',
        _2: '2',
        _3: '3',
        _4: '4'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


